export default "__VITE_ASSET__BMs6xeHr__"